import {
  Field,
  FieldDescription,
  FieldGroup,
  FieldLabel,
  FieldLegend,
  FieldSeparator,
  FieldSet,
} from "@/client/components/shad/field";
import { withForm } from "../../form-context";
import { adminFormOptions } from "../shared";
import {
  InputOTP,
  InputOTPGroup,
  InputOTPSlot,
} from "@/client/components/shad/input-otp";
import { Button } from "@/client/components/shad/button";
import { useState } from "react";
import { ButtonGroup } from "@/client/components/shad/button-group";
import { IconCheck, IconCopy } from "@tabler/icons-react";
import { useStore } from "@tanstack/react-form";

export const OPTBlock = withForm({
  ...adminFormOptions,
  render: function Render({ form }) {
    const [copied, setCopied] = useState(false);
    const currentPin = useStore(form.store, (state) => state.values.pin);

    const handleCopy = async () => {
      try {
        await navigator.clipboard.writeText(currentPin);
        setCopied(true);

        setTimeout(() => setCopied(false), 5000);
      } catch (err) {
        console.error("Failed to copy:", err);
      }
    };

    const generatePin = () => {
      let pin = "";

      for (let i = 0; i < 6; i++) {
        pin += Math.floor(Math.random() * 10);
      }

      return pin;
    };

    const handleGenerate = () => {
      const _pin = generatePin();
      form.setFieldValue("pin", _pin);
    };

    return (
      <FieldSet>
        <FieldLegend>Security PIN</FieldLegend>
        <FieldDescription>
          Set a temporary 6-digit PIN. The user can change this after signing in
          for the first time.
        </FieldDescription>

        <FieldGroup>
          <Field orientation="horizontal">
            <form.AppField name="pin">
              {(field) => <field.OTPField label="Tempory PIN" />}
            </form.AppField>
            <Field>
              <ButtonGroup className="mt-8">
                <Button onClick={handleGenerate} variant="outline">
                  Generate PIN
                </Button>
                <Button
                  onClick={handleCopy}
                  disabled={currentPin.length !== 6}
                  variant="outline"
                >
                  {copied ? (
                    <IconCheck className="text-lime-500" />
                  ) : (
                    <IconCopy />
                  )}
                </Button>
              </ButtonGroup>
            </Field>
          </Field>
        </FieldGroup>
      </FieldSet>
    );
  },
});
